export default __webpack_public_path__ + "static/media/logo12.bf15f8c9.svg";